import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding: 6rem 2rem;
  background-color: #f8fafc;
  overflow: hidden;
`;

export const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  color: #17253D;
  text-align: center;
  margin-bottom: 1rem;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background: linear-gradient(90deg, #3454D1, #0891b2);
    border-radius: 2px;
  }
`;

export const Description = styled.p`
  text-align: center;
  font-size: 1.1rem;
  color: #4B5563;
  max-width: 700px;
  margin: 0 auto 3rem;
  line-height: 1.7;
`;

export const ServerGrid = styled.div`
  margin: 4rem 0;
  
  .swiper {
    padding: 1rem 0.5rem 3rem;
  }
  
  .swiper-pagination {
    bottom: 0;
  }
  
  .swiper-pagination-bullet {
    background: #3454D1;
  }

  .swiper-button-next,
  .swiper-button-prev {
    color: #3454D1;
    
    &:after {
      font-size: 1.5rem;
    }
  }
`;

export const ServerCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  height: 100%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  }
`;

export const ServerImage = styled.div`
  width: 100%;
  height: 140px;
  overflow: hidden;
  background-color: #3454D1;
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .default-img {
    width: 80px;
    height: 80px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    font-weight: bold;
    color: white;
  }
`;

export const ServerInfo = styled.div`
  padding: 1.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  
  h3 {
    font-size: 1.2rem;
    font-weight: 600;
    color: #17253D;
    margin-bottom: 0.5rem;
  }
  
  p {
    color: #4B5563;
    font-size: 0.9rem;
    line-height: 1.5;
    margin-bottom: 1.5rem;
    flex: 1;
  }
`;

export const ServerStats = styled.div`
  display: flex;
  margin-bottom: 1rem;
  
  .stat {
    display: flex;
    align-items: center;
    color: #6B7280;
    font-size: 0.85rem;
    
    svg {
      margin-right: 0.5rem;
      color: #3454D1;
    }
  }
`;

export const ServerLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem;
  background: linear-gradient(90deg, #3454D1, #0891b2);
  color: white;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.3s ease;
  text-decoration: none;
  
  span {
    margin-right: 0.5rem;
  }
  
  &:hover {
    background: linear-gradient(90deg, #294bc7, #077991);
    color: white;
  }
`;

export const JoinCommunity = styled.div`
  text-align: center;
  background: linear-gradient(135deg, #3454D1, #0891b2);
  border-radius: 12px;
  padding: 3rem 2rem;
  color: white;
  margin-top: 3rem;
  
  .icon {
    font-size: 3rem;
    margin-bottom: 1.5rem;
  }
  
  h3 {
    font-size: 1.8rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }
  
  p {
    font-size: 1.1rem;
    opacity: 0.9;
    max-width: 600px;
    margin: 0 auto 2rem;
    line-height: 1.6;
  }
  
  a {
    display: inline-flex;
    align-items: center;
    background: white;
    color: #3454D1;
    padding: 0.75rem 1.5rem;
    border-radius: 50px;
    font-weight: 600;
    transition: all 0.3s ease;
    text-decoration: none;
    
    svg {
      margin-right: 0.5rem;
      font-size: 1.2rem;
    }
    
    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.2);
    }
  }
`;

export const Item = styled.div`
  cursor: pointer;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  
  img {
    width: 100%;
    height: auto;
    border-radius: 12px;
  }
  
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
  }
`;
